import $ from 'jquery';
import * as React from 'react';
import { Redirect, Route, RouteComponentProps, Switch, withRouter } from 'react-router';

// tslint:disable-next-line:no-submodule-imports
import { renderToStaticMarkup } from 'react-dom/server';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import englishTranslations from '../translations/en.json';
import dutchTranslations from '../translations/nl.json';

import { connect } from 'react-redux';
import LoadingScreen from '../components/navigation/LoadingScreen';
import {
    authInitialized, canSeeApplicationsPage, canSeeDatabasePage,
    canSeeGroupsPage, canSeeServersPage, canSeeUsersPage, canSeeWorkspacesPage,
    hideGroups, isLoggedInAs, isOldUser, ssoEnabled, themeBackgroundImage, themeIconImage, themeOrgName, themeFavicon
} from '../stores/auth/selectors';
import { RootState } from '../stores/store';

import DefaultRedirect from './DefaultRedirect';
import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';

import { Button, Card, Spinner } from 'reactstrap';
import AlertContainer from '../components/alerts/AlertContainer';
import ApplicationsPage from '../components/applications/ApplicationsPage';
import EditApplicationPage from '../components/applications/EditApplicationPage';
import NewApplicationPage from '../components/applications/NewApplicationPage';
import AppSelectionPage from '../components/appSelection/AppSelectionPage';
import AnonymousLoginPage from '../components/auth/AnonymousLoginPage';
import ConfirmActiveDirectoryPage from '../components/auth/confirmActiveDirectory/ConfirmActiveDirectoryPage';
import ForgotPasswordPage from '../components/auth/forgotPassword/ForgotPasswordPage';
import LoginPage from '../components/auth/login/LoginPage';
import LogoutPage from '../components/auth/LogoutPage';
import ResetPasswordPage from '../components/auth/resetPassword/ResetPasswordPage';
import UpdateAccountPage from '../components/auth/updateAccount/UpdateAccountPage';
import DashboardContainer from '../components/dashboard/DashboardContainer';
import DatabaseImportPage from '../components/database/DatabaseImportPage';
import DatabaseMenuPage from '../components/database/DatabaseMenuPage';
import EditGroupPage from '../components/groups/EditGroupPage';
import GroupsPage from '../components/groups/GroupsPage';
import NewGroupPage from '../components/groups/NewGroupPage';
import EditServerPage from '../components/servers/EditServerPage';
import NewServerPage from '../components/servers/NewServerPage';
import ServersPage from '../components/servers/ServersPage';
import EditUserPage from '../components/users/EditUserPage';
import NewUserPage from '../components/users/NewUserPage';
import UsersPage from '../components/users/UsersPage';
import EditWorkspacePage from '../components/workspaces/EditWorkspacePage';
import NewWorkspacePage from '../components/workspaces/NewWorkspacePage';
import WorkspacesPage from '../components/workspaces/WorkspacesPage';
import VerifyEmailPage from '../components/auth/verifyEmail/VerifyEmailPage';

// tslint:disable-next-line:no-empty-interface
interface Props extends RouteComponentProps, LocalizeContextProps {
    authInitialized: boolean;
    canSeeUsersPage: boolean;
    canSeeApplicationsPage: boolean;
    canSeeGroupsPage: boolean;
    canSeeServersPage: boolean;
    canSeeDatabasePage: boolean;
    canSeeWorkspacesPage: boolean;
    themeBackgroundImage?: string;
    themeOrgName?: string;
    themeIconImage?: string;
    themeFavicon?: string;
    
    isOldUser?: boolean;
    loggedInAs?: boolean;
    
    ssoEnabled: boolean;
    hideGroups?: boolean;
}

function getLanguage(): string {
    let languages: ReadonlyArray<string>;

    if (navigator.languages) {
        languages = navigator.languages;
    } else {
        languages = [
            // tslint:disable-next-line:no-any
            (navigator as any).browserLanguage,
            // tslint:disable-next-line:no-any
            (navigator as any).userLanguage,
            // tslint:disable-next-line:no-any
            (navigator as any).language,
            // tslint:disable-next-line:no-any
            (navigator as any).systemLanguage
        ];
    }

    for (const language of languages) {
        switch (language.split('-')[0]) {
            case 'en':
                return 'en';
            case 'nl':
                return 'nl';
        }
    }
    return 'en';
}

class Routes extends React.Component<Props> {
    constructor(props: Props) {
        super(props);

        this.props.initialize({
            languages: [
                { name: 'English', code: 'en' },
                { name: 'Nederlands', code: 'nl' }
            ],
            options: {
                defaultLanguage: getLanguage(),
                renderInnerHtml: true,
                renderToStaticMarkup,
            }
        });

        this.props.addTranslationForLanguage(englishTranslations, 'en');
        this.props.addTranslationForLanguage(dutchTranslations, 'nl');
    }

    public render() {
        if (this.props.authInitialized) {
            /* if (this.props.ssoEnabled) {
                window.location.replace(this.props.ssoEntrypoint);
                const t = this.props.translate;
                return <LoadingScreen text={t('loading.loading') as string} />;
            } */
            const t = this.props.translate;
            if (this.props.themeFavicon) { 
                let faviconObject: any = document.getElementById("favicon");
                if (faviconObject && faviconObject.href !== this.props.themeFavicon) {
                    faviconObject.href = this.props.themeFavicon
                }
            }
            let htmlObject: any = document.getElementById("html");
            htmlObject.lang = getLanguage();
            if (!String.prototype.startsWith) {
                String.prototype.startsWith = function(searchString, position) {
                  position = position || 0;
                  return this.substr(position, searchString.length) === searchString;
              };
            }
            
            if (this.props.isOldUser && !this.props.loggedInAs &&
                (!this.props.location.pathname.startsWith('/update') &&
                    !this.props.location.pathname.startsWith('/reset-password') && 
                    !this.props.location.pathname.startsWith('/confirm-migration') && 
                    !this.props.location.pathname.startsWith('/logout'))) {
                return <Redirect to={{ pathname: '/update' }} />;
            }
            return (
                <React.Fragment>
                    <div
                        className="theme-bg"
                        style={{
                            backgroundImage: this.props.location.pathname.startsWith('/login') && this.props.themeBackgroundImage ?
                                `url(${this.props.themeBackgroundImage})` : '',
                        }}
                    />
                    <AlertContainer />
                    <Switch>
                        <PublicRoute path="/login" component={LoginPage} />
                        <PublicRoute path="/anonymousLogin" component={AnonymousLoginPage} />
                        <PublicRoute path="/logout" component={LogoutPage} />
                        <PublicRoute path="/forgot-password" component={ForgotPasswordPage} />
                        <PublicRoute path="/reset-password/:id" component={ResetPasswordPage} />
                        <PublicRoute path="/confirm-migration/:id" component={ConfirmActiveDirectoryPage} />
                        <PublicRoute path="/verify-email/:id" component={VerifyEmailPage} />
                        {/* <PublicRoute path="/zendesk/sso" component={LoginPage} /> */}
                        {/* <PublicRoute path="/sso/lastpass" component={SSOPage} /> */}
                        <PrivateRoute path="/change-password" component={ForgotPasswordPage} />

                        <PrivateRoute path="/select-app" component={AppSelectionPage} />
                        <PrivateRoute
                            path="/update"
                            exact={true}
                            filter={this.props.isOldUser}
                            component={UpdateAccountPage} /* allow_old_users={true} */
                        />

                        <Route>
                            <DashboardContainer>
                                <Switch>
                                    <PrivateRoute
                                        path="/database"
                                        exact={true}
                                        filter={this.props.canSeeDatabasePage}
                                        component={DatabaseMenuPage}
                                    />
                                    <PrivateRoute
                                        path="/database/import"
                                        exact={true}
                                        filter={this.props.canSeeDatabasePage}
                                        component={DatabaseImportPage}
                                    />
                                    <Route path="/users">
                                        <PrivateRoute
                                            path="/users"
                                            filter={this.props.canSeeUsersPage}
                                            component={UsersPage}
                                        />
                                        <Switch>
                                            <PrivateRoute
                                                path="/users/new"
                                                component={NewUserPage}
                                            />
                                            <PrivateRoute
                                                path="/users/edit/:id"
                                                component={EditUserPage}
                                            />
                                            <PrivateRoute
                                                path="/users/copy/:id"
                                                component={NewUserPage}
                                            />
                                        </Switch>
                                    </Route>

                                    <Route path="/applications">
                                        <PrivateRoute
                                            path="/applications"
                                            filter={this.props.canSeeApplicationsPage}
                                            component={ApplicationsPage}
                                        />
                                        <Switch>
                                            <PrivateRoute
                                                path="/applications/new"
                                                component={NewApplicationPage}
                                            />
                                            <PrivateRoute
                                                path="/applications/edit/:id"
                                                component={EditApplicationPage}
                                            />
                                            <PrivateRoute
                                                path="/applications/copy/:id"
                                                component={NewApplicationPage}
                                            />
                                        </Switch>
                                    </Route>
                                    {this.props.hideGroups === undefined || this.props.hideGroups === false ? (
                                        <Route path="/groups">
                                            <PrivateRoute
                                                title={t('groups.header.groups') + this.title()}
                                                path="/groups"
                                                filter={this.props.canSeeGroupsPage}
                                                component={GroupsPage}
                                            />
                                            <Switch>
                                                <PrivateRoute
                                                    path="/groups/new"
                                                    component={NewGroupPage}
                                                />
                                                <PrivateRoute
                                                    path="/groups/edit/:id"
                                                    component={EditGroupPage}
                                                />
                                                <PrivateRoute
                                                    path="/groups/copy/:id"
                                                    component={NewGroupPage}
                                                />
                                            </Switch>
                                        </Route>
                                    ) : null}
                                    <Route path="/workspaces">
                                        <PrivateRoute
                                            path="/workspaces"
                                            filter={this.props.canSeeWorkspacesPage}
                                            component={WorkspacesPage}
                                        />
                                        <Switch>
                                            <PrivateRoute
                                                path="/workspaces/new"
                                                component={NewWorkspacePage}
                                            />
                                            <PrivateRoute
                                                path="/workspaces/edit/:id"
                                                component={EditWorkspacePage}
                                            />
                                            <PrivateRoute
                                                path="/workspaces/copy/:id"
                                                component={NewWorkspacePage}
                                            />
                                        </Switch>
                                    </Route>
                                    <Route path="/servers">
                                        <PrivateRoute
                                            path="/servers"
                                            filter={this.props.canSeeServersPage}
                                            component={ServersPage}
                                        />
                                        <Switch>
                                            <PrivateRoute
                                                path="/servers/new"
                                                component={NewServerPage}
                                            />
                                            <PrivateRoute
                                                path="/servers/edit/:id"
                                                component={EditServerPage}
                                            />
                                            <PrivateRoute
                                                path="/servers/copy/:id"
                                                component={NewServerPage}
                                            />
                                        </Switch>
                                    </Route>
                                    <Route component={DefaultRedirect} />
                                </Switch>
                            </DashboardContainer>
                        </Route>
                    </Switch>
                </React.Fragment>
            );
        } else {
            const t = this.props.translate;
            return (
                <React.Fragment>
                    <AlertContainer />
                    <LoadingScreen text={t('loading.loading') as string} />
                </React.Fragment>
            );
        }
    }

    private title = () => {
        if (this.props.themeOrgName) {
            return ' - ' + this.props.themeOrgName;
        } else {
            return ' - AAS';
        }
    }
}

const mapStateToProps = (state: RootState) => ({
    authInitialized: authInitialized(state),
    canSeeApplicationsPage: canSeeApplicationsPage(state),
    canSeeDatabasePage: canSeeDatabasePage(state),
    canSeeGroupsPage: canSeeGroupsPage(state),
    canSeeServersPage: canSeeServersPage(state),
    canSeeUsersPage: canSeeUsersPage(state),
    canSeeWorkspacesPage: canSeeWorkspacesPage(state),
    hideGroups: hideGroups(state),
    isOldUser: isOldUser(state),
    loggedInAs: isLoggedInAs(state),
    themeBackgroundImage: themeBackgroundImage(state),
    themeIconImage: themeIconImage(state),
    themeOrgName: themeOrgName(state),
    themeFavicon: themeFavicon(state),
    
    ssoEnabled: ssoEnabled(state),
});

const routesWithRouter = connect(mapStateToProps)(withLocalize(withRouter(Routes)));
export { routesWithRouter as Routes };
